import 'core-js/features/string/replace-all';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from 'react-query';
import App from './App';
import './index.scss';
import ReactGA from 'react-ga';
import { createStore } from 'redux';
import rootReducer from './reducers';
import { Provider } from 'react-redux';
import * as Sentry from '@sentry/react';
import { ReactQueryDevtools } from 'react-query/devtools';
import * as serviceWorkerRegistration from './serviceWorkerRegistration'; //PWA
// import ReactPixel from 'react-facebook-pixel';

// const PIXEL_ID = '924920305590436';
// ReactPixel.init(PIXEL_ID);
// serviceWorkerRegistration.register();
serviceWorkerRegistration.unregister();
const TRACKING_ID = process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID; // 발급받은 추적ID를 환경 변수로 불러온다.
ReactGA.initialize(TRACKING_ID || '');
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
if (!window.location.hostname.includes('localhost'))
    Sentry.init({
        dsn: 'https://d434030f726a12599dfce29cb1fe371a@sentry.shorton.kr/17',
        // 성능 모니터링 설정
        integrations: [
            Sentry.browserTracingIntegration(),
            // Session Replay: 사용자 행동 재현 기능
            Sentry.replayIntegration({
                // 개인정보 보호를 위해 모든 텍스트를 가립니다.
                maskAllText: false,
                // 모든 CSS 인풋(input) 요소를 가립니다.
                blockAllMedia: false,
            }),
        ],

        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 0.1,
        // Session Replay 수집 비율
        // 전체 세션의 10%를 녹화
        replaysSessionSampleRate: 0.1,
        // 에러가 발생한 세션은 100% 녹화
        replaysOnErrorSampleRate: 1.0,
        environment: 'WEB'
    });
const queryClient = new QueryClient();

const store = createStore(rootReducer);
root.render(
  <QueryClientProvider client={queryClient}>
    <Provider store={store}>
      <App />

      <ReactQueryDevtools initialIsOpen={true} />
    </Provider>
  </QueryClientProvider>,
);
